import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useParams } from 'react-router-dom';
import FilterChips from 'feature/dispatching/components/FilterChips';
import { useViewTrailerSummaryByLocationQuery } from '../../trailerStatusEndpoints';
import LocationControls from './LocationControls';

const boxStyles = {
  alignItems: 'center',
  backgroundColor: 'surface.light',
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  overflow: 'hidden',
  p: 3,
  position: 'sticky',
  textOverflow: 'ellipsis',
  top: 48,
  zIndex: 2,
};

const LocationHeader = ({
  cardsFilters,
  defaultFiltersState,
  onResetFilters,
  setCardsFilters,
  onCreateTrailer,
  onRemoveFilter,
}) => {
  const { viewById } = useParams();

  // prettier-ignore
  const locationsFilter = R.compose(
    R.equals(parseInt(viewById)), 
    R.prop('locationId'),
  );

  const {
    data = [],
    isLoading,
    isSuccess,
  } = useViewTrailerSummaryByLocationQuery(undefined, {
    skip: R.isNil(viewById),
  });
  const location = data.find(locationsFilter) ?? {};

  const { locationId, name = {} } = location;
  const locationTitle = isLoading
    ? 'Loading...'
    : isSuccess
    ? `${locationId} ${R.toUpper(name)}`
    : '';

  return (
    <Box sx={boxStyles}>
      <Typography noWrap sx={{ alignSelf: 'end', color: 'text.primary' }} variant="h5">
        {locationTitle}
      </Typography>
      <Typography noWrap sx={{ alignSelf: 'start', gridRowStart: 2 }} variant="body2">
        {location.address}
      </Typography>
      <Box sx={{ gridRowStart: 3 }}>
        <FilterChips
          defaultState={defaultFiltersState}
          filters={cardsFilters}
          onRemove={onRemoveFilter}
        />
      </Box>
      <Box sx={{ alignSelf: 'start', gridColumn: 2 }}>
        <LocationControls
          cardsFilters={cardsFilters}
          defaultFiltersState={defaultFiltersState}
          isLoading={isLoading}
          isSuccess={isSuccess}
          onCreateTrailer={onCreateTrailer}
          resetFilters={onResetFilters}
          setCardsFilters={setCardsFilters}
        />
      </Box>
    </Box>
  );
};

LocationHeader.propTypes = {
  cardsFilters: PropTypes.shape({}).isRequired,
  defaultFiltersState: PropTypes.shape({}).isRequired,
  onCreateTrailer: PropTypes.func.isRequired,
  onRemoveFilter: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
};

export default LocationHeader;
